import { EmblaPaginationContext } from 'contexts/providers/EmblaPaginationProvider'
import { useContext } from 'react'

export function useEmblaPagination() {
  return useContext(EmblaPaginationContext)
}
